// Leaf module, like auth-tokens: importable from anywhere - Sentry's options
// among them - without dragging in AuthenticationService's module graph.

/** Matched by name in `SENTRY_OPTIONS.beforeSend`; keep the two in step. */
export const SESSION_EXPIRED_ERROR_NAME = 'SessionExpiredError';

/**
 * The session is over and cannot be renewed: the visitor has to sign in again.
 *
 * A state, not a defect, and the reason it has a type of its own. It ends a
 * request the way a rejected refresh does, so callers still see a failure, but
 * Sentry drops it: an expiring session is what sessions do, and reporting it
 * buried real failures under 8.8K events from 555 people whose only problem
 * was that they had been away for a while.
 */
export class SessionExpiredError extends Error {
  constructor(reason: string, cause?: unknown) {
    super(`Session expired: ${reason}`, { cause });
    this.name = SESSION_EXPIRED_ERROR_NAME;
  }
}
